<nz-modal
  [(nzVisible)]="modalVisible"
  [nzTitle]="titleTpl"
  [nzWidth]="560"
  nzDraggable
  nzOkText="Yes"
  (nzOnOk)="handleOk()"
  nzCancelText="No"
  (nzOnCancel)="handleCancel()"
>
  <ng-template #titleTpl>
    <div class="modal-title-container">
      <i nz-icon nzType="exclamation-circle" nzTheme="outline" class="warning-icon"></i>
      <span class="title-font-weight">Reminder: e-Invoice Issuance is Required</span>
    </div>
  </ng-template>
  <ng-container *nzModalContent>
    <p>
      Stock items in this transaction have been defined as requiring individual
      e-Invoices. As a result, these items cannot be included in a consolidated
      e-Invoice submission.
    </p>
    <p>
      To ensure compliance with e-Invoice regulations, would you like to switch
      your validation setting to <b><u>Full Validation</u></b> now?
    </p>
  </ng-container>
</nz-modal>
